var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"fondo-btn-cabecera",attrs:{"depressed":"","disabled":_vm.disabled,"fab":"","x-small":"","ripple":false},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"s-menu-pc__list-icon",attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }